import { useState, useEffect } from "react";

function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div className="flex items-center gap-2 font-medium">
      <div className="relative flex h-2.5 w-2.5 items-center justify-center">
        {isOnline ? (
          <>
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
          </>
        ) : (
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
        )}
      </div>
      <span className={isOnline ? "text-green-500" : "text-red-500"}>
        {isOnline ? "Online" : "Offline"}
      </span>
    </div>
  );
}

export function FooterA() {
  return (
    <footer className="p-4 text-white text-sm">
      <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto gap-4 md:gap-0">
        <div>© {new Date().getFullYear()} Developed By SSA</div>
        <NetworkStatus />
        <div>Financed By GCF</div>
      </div>
    </footer>
  );
}

export function FooterB() {
  return (
    <footer className="p-4 text-sm">
      <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto gap-4 md:gap-0">
        <div className="text-lime-100">
          © {new Date().getFullYear()} Developed By SSA
        </div>
        <NetworkStatus />
        <div className="text-lime-100">Financed By GCF</div>
      </div>
    </footer>
  );
}

export default function Footer({ variant = "a" }: { variant?: "a" | "b" }) {
  return variant === "a" ? <FooterA /> : <FooterB />;
}

